import React from "react";
import Checkbox from "src/scenes/EmailCampaigns/components/Checkbox";
import { StyledCountryPhoneInput } from "src/scenes/EmailCampaigns/components/style";
import { CardTableCell, CardTableCellHeader, CardTableRow, FormField } from "src/components";

const CONTACT_COLUMNS = [
    { field: "firstName", label: "First Name" },
    { field: "lastName", label: "Last Name" },
    { field: "email", label: "Email" },
    { field: "mobileNumber", label: "Mobile" },
    { field: "reference", label: "Reference" },
];

export const Rows = ({
    tableData,
    onToggle,
    isSelected,
    isViewingContacts = true,
    countryCode = null,
    onChangeField,
    errors,
    onSort,
    isSortable = () => false,
}) => {
    const canEdit = !isViewingContacts && typeof onChangeField === "function";

    const renderHeader = (column, columnIndex) => {
        const sortableIndex = isViewingContacts ? columnIndex : columnIndex + 1;
        const sortable = isSortable(sortableIndex);

        return (
            <CardTableCellHeader
                onClick={sortable ? () => onSort(sortableIndex) : undefined}
                style={{ cursor: sortable ? "pointer" : "default" }}
            >
                {column.label}
            </CardTableCellHeader>
        );
    };

    const renderRow = (item, index) => (
        <CardTableRow
            key={item.uuid || index}
            selected={!isViewingContacts && isSelected(index)}
            columns={isViewingContacts
                ? "repeat(5, minmax(9rem, 1fr))"
                : "2.25rem repeat(5, minmax(9rem, 1fr))"}
            minWidth={isViewingContacts ? "760px" : "860px"}
            padding="1rem 0.85rem"
        >
            {!isViewingContacts && (
                <CardTableCell alignItems="center">
                    <CardTableCellHeader>
                        Select
                    </CardTableCellHeader>
                    <label>
                        <Checkbox
                            readOnly
                            checked={isSelected(index)}
                            value={item.uuid}
                            onMouseDown={(e) => e.preventDefault()}
                            onChange={(e) => onToggle(index, e)}
                        />
                    </label>
                </CardTableCell>
            )}
            <CardTableCell>
                {renderHeader(CONTACT_COLUMNS[0], 0)}
                <RowItem
                    value={item.firstName}
                    field="firstName"
                    index={index}
                    isSelected={isSelected(index)}
                    errors={errors}
                    onChangeField={onChangeField}
                    isDisabled={!canEdit}
                />
            </CardTableCell>

            <CardTableCell>
                {renderHeader(CONTACT_COLUMNS[1], 1)}
                <RowItem
                    value={item.lastName}
                    field="lastName"
                    index={index}
                    isSelected={isSelected(index)}
                    errors={errors}
                    onChangeField={onChangeField}
                    isDisabled={!canEdit}
                />
            </CardTableCell>
            <CardTableCell>
                {renderHeader(CONTACT_COLUMNS[2], 2)}
                <RowItem
                    value={item.email}
                    field="email"
                    index={index}
                    isSelected={isSelected(index)}
                    isDuplicate={item.isDuplicate}
                    errors={errors}
                    onChangeField={onChangeField}
                    isDisabled={!canEdit}
                />
            </CardTableCell>
            <CardTableCell>
                {renderHeader(CONTACT_COLUMNS[3], 3)}
                <StyledCountryPhoneInput
                    autoFormat={false}
                    prefix={"+"}
                    showErrors={true}
                    country={countryCode?.toLowerCase()}
                    value={item.mobileNumber}
                    placeholder={"Mobile number"}
                    style={{ marginTop: 5 }}
                    disabled={!canEdit}
                    onChange={(value) =>
                        canEdit && onChangeField(index, "mobileNumber", value)
                    }
                />
            </CardTableCell>
            <CardTableCell>
                {renderHeader(CONTACT_COLUMNS[4], 4)}
                <RowItem
                    value={item.reference}
                    field="reference"
                    index={index}
                    isSelected={isSelected(index)}
                    errors={errors}
                    onChangeField={onChangeField}
                    isDisabled={!canEdit}
                />
            </CardTableCell>
        </CardTableRow>
    );

    return <>{tableData.map(renderRow)}</>;
};

const RowItem = ({ value, field, index, isSelected, isDuplicate, onChangeField, errors, isDisabled }) => {
    const error = errors?.[index]?.[field];

    return (
        <FormField
            borderRadius="10px"
            height="38px"
            border={
                error
                    ? "1px solid red"
                    : isDuplicate
                        ? "1px solid red"
                        : isSelected
                            ? "1px solid #016CFF"
                            : "1px solid #D8DEEC"
            }
            backgroundColor={isSelected ? "rgba(91, 110, 245, 0.12)" : "#F4F4F4"}
            value={value || ""}
            onChange={(e) => onChangeField && onChangeField(index, field, e.target.value)}
            isDisabled={isDisabled}
            style={{ textAlign: "left" }}
            errors={errors}
        />
    );
};
